module.exports = __webpack_public_path__ + "static/media/fitness.d6a9aa6d.svg";